import { render, staticRenderFns } from "./search-payments.vue?vue&type=template&id=162515a2&scoped=true&"
import script from "./search-payments.vue?vue&type=script&lang=js&"
export * from "./search-payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162515a2",
  null
  
)

export default component.exports